import { fetchGlobalParams, fetchStudentReduction } from '../queries/globalParams.queries'

import { useQuery } from '@tanstack/react-query'

export const useGlobalParams = () =>
  useQuery({
    queryKey: ['globalParams'],
    queryFn: fetchGlobalParams,
  })

export const useStudentReduction = () =>
  useQuery({
    queryKey: ['studentReduction'],
    queryFn: fetchStudentReduction,
  })
